import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { BarChart3 } from "lucide-react";
import { toast } from "sonner";

export function AccountingReportsPeriodSelector({
  period,
  dateFrom,
  dateTo,
  loading,
  onPeriodChange,
  onDateFromChange,
  onDateToChange,
  onGenerateReport,
}) {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-lg">Generar Informe Contable</CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="grid grid-cols-2 md:grid-cols-5 gap-2">
          <Button
            variant={period === "1month" ? "default" : "outline"}
            onClick={() => onPeriodChange("1month")}
            className="w-full"
          >
            1 Mes
          </Button>
          <Button
            variant={period === "2months" ? "default" : "outline"}
            onClick={() => onPeriodChange("2months")}
            className="w-full"
          >
            2 Meses
          </Button>
          <Button
            variant={period === "3months" ? "default" : "outline"}
            onClick={() => onPeriodChange("3months")}
            className="w-full"
          >
            3 Meses
          </Button>
          <Button
            variant={period === "custom" ? "default" : "outline"}
            onClick={() => onPeriodChange("custom")}
            className="w-full"
          >
            Personalizado
          </Button>
        </div>

        {period === "custom" && (
          <div className="grid grid-cols-2 gap-4 mt-4">
            <div>
              <label className="text-sm font-medium">Fecha inicial</label>
              <input
                type="date"
                value={dateFrom}
                onChange={(e) => onDateFromChange(e.target.value)}
                className="w-full px-3 py-2 border rounded-md mt-1"
              />
            </div>
            <div>
              <label className="text-sm font-medium">Fecha final</label>
              <input
                type="date"
                value={dateTo}
                onChange={(e) => onDateToChange(e.target.value)}
                className="w-full px-3 py-2 border rounded-md mt-1"
              />
            </div>
          </div>
        )}

        <Button
          onClick={onGenerateReport}
          className="w-full gap-2 bg-blue-600 hover:bg-blue-700"
          disabled={loading}
        >
          <BarChart3 className="w-4 h-4" />
          Generar Informe
        </Button>
      </CardContent>
    </Card>
  );
}
